import { NoData } from "../SVGs";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const customStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "40vh",
    maxHeight: "100%",
    justifyContent: "center",
    width: "100%",
    "& > span": {
      fontSize: "16px",
      fontWeight: "bold",
      width: "30vw",
      textAlign: "center",
      color: "rgb(0 0 0)",
      paddingTop: "1rem",
      direction: "ltr",
    },
  },
};
const defaultIcon = <NoData sx={{ fontSize: "3.5rem !important" }} />;

function DataNotFound({ text, icon = defaultIcon, style }) {
  return (
    <Box sx={{ ...customStyles.root, ...style }}>
      {icon}
      <span>{text}</span>
    </Box>
  );
}

DataNotFound.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.node,
  style: PropTypes.object,
};

export default DataNotFound;
